// Code generated by tools/enummirror; DO NOT EDIT.
// Every enum api/openapi.yaml declares, as the runtime arrays the option
// lists read (#193). Regenerate with `make generate`; a stale copy fails
// generate-check in CI.
//
// Each array is typed against the generated schema, so a value here is one
// the type allows. A page labels one through a Record<Enum, string>, which
// the typecheck forces complete.
import type { components } from "./schema";

/** `AAALogEntryKind` */
export const AAA_LOG_ENTRY_KIND: readonly components["schemas"]["AAALogEntryKind"][] = ["auth", "acct"];

/** `AAALogEntryResult` */
export const AAA_LOG_ENTRY_RESULT: readonly components["schemas"]["AAALogEntryResult"][] = ["accept", "reject", "recorded", "unanswered"];

/** `AccessPointClientsState` */
export const ACCESS_POINT_CLIENTS_STATE: readonly components["schemas"]["AccessPointClientsState"][] = ["reported", "no_wireless", "unanswered", "stale", "offline", "unknown"];

/** `AccessPointPortStateLink` */
export const ACCESS_POINT_PORT_STATE_LINK: readonly components["schemas"]["AccessPointPortStateLink"][] = ["up", "down"];

/** `AccessPointPortsUnansweredReason` */
export const ACCESS_POINT_PORTS_UNANSWERED_REASON: readonly components["schemas"]["AccessPointPortsUnansweredReason"][] = ["offline", "unknown", "no_report", "unreadable", "silent"];

/** `AccessPointRadioKind` */
export const ACCESS_POINT_RADIO_KIND: readonly components["schemas"]["AccessPointRadioKind"][] = ["added", "changed", "removed"];

/** `AccessPointRadiosState` */
export const ACCESS_POINT_RADIOS_STATE: readonly components["schemas"]["AccessPointRadiosState"][] = ["reported", "no_wireless", "unanswered", "stale", "offline", "unknown"];

/** `ApplyConfirmWindowState` */
export const APPLY_CONFIRM_WINDOW_STATE: readonly components["schemas"]["ApplyConfirmWindowState"][] = ["armed", "confirmed", "cancelled", "not_confirmed", "superseded", "void"];

/** `ApplyKind` */
export const APPLY_KIND: readonly components["schemas"]["ApplyKind"][] = ["site_config", "device_config", "site_reconcile", "carried_apply", "carried_seed", "work_list", "vlan_references", "switch_ports", "switch_first_document", "switch_cli_settings", "site_gateway"];

/** `ApplyState` */
export const APPLY_STATE: readonly components["schemas"]["ApplyState"][] = ["accepted", "running", "done", "refused", "failed", "unknown", "interrupted"];

/** `ApplyTargetKind` */
export const APPLY_TARGET_KIND: readonly components["schemas"]["ApplyTargetKind"][] = ["switch", "access_point", "venue", "router"];

/** `AttentionItemKind` */
export const ATTENTION_ITEM_KIND: readonly components["schemas"]["AttentionItemKind"][] = ["offline_device", "unknown_device", "site_no_cell", "site_no_venue", "cell_failed", "state_not_read", "stale_report"];

/** `AuditEventActorType` */
export const AUDIT_EVENT_ACTOR_TYPE: readonly components["schemas"]["AuditEventActorType"][] = ["user", "token", "system"];

/** `AuditEventResult` */
export const AUDIT_EVENT_RESULT: readonly components["schemas"]["AuditEventResult"][] = ["ok", "rejected", "failed"];

/** `AuthMethodKind` */
export const AUTH_METHOD_KIND: readonly components["schemas"]["AuthMethodKind"][] = ["oidc"];

/** `AuthMethodScopeType` */
export const AUTH_METHOD_SCOPE_TYPE: readonly components["schemas"]["AuthMethodScopeType"][] = ["org", "customer"];

/** `AuthMethodState` */
export const AUTH_METHOD_STATE: readonly components["schemas"]["AuthMethodState"][] = ["created", "verified", "enabled", "disabled"];

/** `Band` */
export const BAND: readonly components["schemas"]["Band"][] = ["2G", "5G", "6G"];

/** `BrandAssetKind` */
export const BRAND_ASSET_KIND: readonly components["schemas"]["BrandAssetKind"][] = ["logo", "favicon", "logo_dark"];

/** `BrandFace` */
export const BRAND_FACE: readonly components["schemas"]["BrandFace"][] = ["plex-sans", "open-sans", "inter", "figtree", "outfit", "montserrat", "poppins", "lato", "roboto"];

/** `BrandFaceMono` */
export const BRAND_FACE_MONO: readonly components["schemas"]["BrandFaceMono"][] = ["plex-mono"];

/** `BrandSource` */
export const BRAND_SOURCE: readonly components["schemas"]["BrandSource"][] = ["organization", "default"];

/** `BriefingOutcome` */
export const BRIEFING_OUTCOME: readonly components["schemas"]["BriefingOutcome"][] = ["answered", "declined"];

/** `CarriedFirmwareRestatedRevalidation` */
export const CARRIED_FIRMWARE_RESTATED_REVALIDATION: readonly components["schemas"]["CarriedFirmwareRestatedRevalidation"][] = ["passed", "failed", "unavailable"];

/** `CarriedPlanRootPasswordChange` */
export const CARRIED_PLAN_ROOT_PASSWORD_CHANGE: readonly components["schemas"]["CarriedPlanRootPasswordChange"][] = ["changes", "unchanged", "unknown"];

/** `CarriedPlanRootPasswordRoute` */
export const CARRIED_PLAN_ROOT_PASSWORD_ROUTE: readonly components["schemas"]["CarriedPlanRootPasswordRoute"][] = ["carried_apply", "reconciliation", "unknown"];

/** `CarriedPlanRootPasswordUnknownBecause` */
export const CARRIED_PLAN_ROOT_PASSWORD_UNKNOWN_BECAUSE: readonly components["schemas"]["CarriedPlanRootPasswordUnknownBecause"][] = ["no_sealed_password", "several_sealed_passwords", "no_held_document", "unreadable_record"];

/** `CarriedRadioSettingField` */
export const CARRIED_RADIO_SETTING_FIELD: readonly components["schemas"]["CarriedRadioSettingField"][] = ["minimum_rate_mbps", "legacy_rates", "maximum_clients", "multiple_bssid"];

/** `CarryOverItemDisposition` */
export const CARRY_OVER_ITEM_DISPOSITION: readonly components["schemas"]["CarryOverItemDisposition"][] = ["modelled", "carried", "refused", "undeliverable_at_pin", "unqualified_pending_firmware"];

/** `CatalogueActRequest.act` */
export const CATALOGUE_ACT_REQUEST_ACT: readonly NonNullable<components["schemas"]["CatalogueActRequest"]["act"]>[] = ["update", "delete", "promote", "merge"];

/** `CatalogueEntryScope` */
export const CATALOGUE_ENTRY_SCOPE: readonly components["schemas"]["CatalogueEntryScope"][] = ["global", "private"];

/** `CataloguePreviewAct` */
export const CATALOGUE_PREVIEW_ACT: readonly components["schemas"]["CataloguePreviewAct"][] = ["update", "delete", "promote", "merge"];

/** `CdsRecordState` */
export const CDS_RECORD_STATE: readonly components["schemas"]["CdsRecordState"][] = ["points_here", "points_elsewhere", "not_readable", "held_by_shasta", "no_record", "unknown"];

/** `CdsTransferCdsState` */
export const CDS_TRANSFER_CDS_STATE: readonly components["schemas"]["CdsTransferCdsState"][] = ["points_here", "points_elsewhere", "not_readable", "held_by_shasta", "no_record", "unknown"];

/** `CdsTransferHeldReason` */
export const CDS_TRANSFER_HELD_REASON: readonly components["schemas"]["CdsTransferHeldReason"][] = ["no_applied_document", "site_cannot_apply", "switch_cannot_apply", "switch_first_document_open"];

/** `CdsTransferState` */
export const CDS_TRANSFER_STATE: readonly components["schemas"]["CdsTransferState"][] = ["awaiting_approval", "held_for_apply", "pending", "accepted", "transferred", "refused", "failed"];

/** `CdsTransferTrigger` */
export const CDS_TRANSFER_TRIGGER: readonly components["schemas"]["CdsTransferTrigger"][] = ["onboarding", "cutover"];

/** `CellLivenessCopy` */
export const CELL_LIVENESS_COPY: readonly components["schemas"]["CellLivenessCopy"][] = ["counted", "stale", "none"];

/** `CellLivenessGroupPlacement` */
export const CELL_LIVENESS_GROUP_PLACEMENT: readonly components["schemas"]["CellLivenessGroupPlacement"][] = ["site", "venue", "elsewhere", "unplaced"];

/** `CellSiteSource` */
export const CELL_SITE_SOURCE: readonly components["schemas"]["CellSiteSource"][] = ["manual", "orbit"];

/** `CellWritesReason` */
export const CELL_WRITES_REASON: readonly components["schemas"]["CellWritesReason"][] = ["moving", "unconfirmed", "refused"];

/** `ChangeAnnouncementKind` */
export const CHANGE_ANNOUNCEMENT_KIND: readonly components["schemas"]["ChangeAnnouncementKind"][] = ["copy", "refill", "firmware_delivery", "apply", "device_import", "switch_read"];

/** `ChannelAuthorKind` */
export const CHANNEL_AUTHOR_KIND: readonly components["schemas"]["ChannelAuthorKind"][] = ["person", "service"];

/** `ChannelMapRadioOverridden` */
export const CHANNEL_MAP_RADIO_OVERRIDDEN: readonly components["schemas"]["ChannelMapRadioOverridden"][] = ["channel", "channel_width", "mode", "tx_power"];

/** `ComparisonDisposition` */
export const COMPARISON_DISPOSITION: readonly components["schemas"]["ComparisonDisposition"][] = ["agree", "differs", "only_in_plan", "only_in_estate", "unanswered"];

/** `ComparisonFacet` */
export const COMPARISON_FACET: readonly components["schemas"]["ComparisonFacet"][] = ["inventory", "topology", "ports", "venue", "reach"];

/** `ComparisonFieldDisposition` */
export const COMPARISON_FIELD_DISPOSITION: readonly components["schemas"]["ComparisonFieldDisposition"][] = ["agree", "differs", "unanswered"];

/** `ComparisonReasonCode` */
export const COMPARISON_REASON_CODE: readonly components["schemas"]["ComparisonReasonCode"][] = ["cell", "unplaced", "no_venue", "absent", "offline", "no_gateway_record", "no_configuration", "no_report", "unreadable", "silent", "vocabulary", "model_unrecognised", "carried", "unmanaged", "refused", "not_measured", "truncated", "unknown", "no_join", "not_served", "no_uplink"];

/** `ComparisonSwitchReadStatus` */
export const COMPARISON_SWITCH_READ_STATUS: readonly components["schemas"]["ComparisonSwitchReadStatus"][] = ["read", "unanswered", "truncated"];

/** `ConfigAppliedPushState` */
export const CONFIG_APPLIED_PUSH_STATE: readonly components["schemas"]["ConfigAppliedPushState"][] = ["pending", "running", "done", "failed", "unknown"];

/** `ConfigPlanAdministrativePassword` */
export const CONFIG_PLAN_ADMINISTRATIVE_PASSWORD: readonly components["schemas"]["ConfigPlanAdministrativePassword"][] = ["set", "replaced", "unchanged"];

/** `ConsoleLoginVerdictVerdict` */
export const CONSOLE_LOGIN_VERDICT_VERDICT: readonly components["schemas"]["ConsoleLoginVerdictVerdict"][] = ["accepted", "refused", "no-prompt", "closed", "error", "not-engaged"];

/** `ConsoleOutcomeEnded` */
export const CONSOLE_OUTCOME_ENDED: readonly components["schemas"]["ConsoleOutcomeEnded"][] = ["abandoned_before_dialback", "viewport_unreachable", "hijack_failed", "viewport_refused_upgrade"];

/** `CustomerSiteReadStatus` */
export const CUSTOMER_SITE_READ_STATUS: readonly components["schemas"]["CustomerSiteReadStatus"][] = ["read", "unconfirmed", "moving", "unplaced", "unanswered", "truncated"];

/** `CutoverReadinessReason` */
export const CUTOVER_READINESS_REASON: readonly components["schemas"]["CutoverReadinessReason"][] = ["placement", "no_access_points"];

/** `CutoverRequestDeviceAction` */
export const CUTOVER_REQUEST_DEVICE_ACTION: readonly components["schemas"]["CutoverRequestDeviceAction"][] = ["decide", "resend", "skip"];

/** `DeviceCategory` */
export const DEVICE_CATEGORY: readonly components["schemas"]["DeviceCategory"][] = ["ap", "switch"];

/** `DeviceCommandRequest.command` */
export const DEVICE_COMMAND_REQUEST_COMMAND: readonly NonNullable<components["schemas"]["DeviceCommandRequest"]["command"]>[] = ["reboot", "blink", "factory"];

/** `DeviceCommandResultCommand` */
export const DEVICE_COMMAND_RESULT_COMMAND: readonly components["schemas"]["DeviceCommandResultCommand"][] = ["reboot", "blink", "factory"];

/** `DeviceConvergenceCategory` */
export const DEVICE_CONVERGENCE_CATEGORY: readonly components["schemas"]["DeviceConvergenceCategory"][] = ["ap", "switch"];

/** `DeviceConvergenceHeldAgainstSent` */
export const DEVICE_CONVERGENCE_HELD_AGAINST_SENT: readonly components["schemas"]["DeviceConvergenceHeldAgainstSent"][] = ["differs", "not_compared"];

/** `DeviceConvergenceState` */
export const DEVICE_CONVERGENCE_STATE: readonly components["schemas"]["DeviceConvergenceState"][] = ["synchronized", "synchronizing", "behind", "offline", "carried", "unknown", "frozen"];

/** `DeviceFirmwareCatalogReadState` */
export const DEVICE_FIRMWARE_CATALOG_READ_STATE: readonly components["schemas"]["DeviceFirmwareCatalogReadState"][] = ["read", "unavailable"];

/** `DeviceFirmwareRequestEntryAcceptances` */
export const DEVICE_FIRMWARE_REQUEST_ENTRY_ACCEPTANCES: readonly components["schemas"]["DeviceFirmwareRequestEntryAcceptances"][] = ["firmware_line_change", "unqualified_firmware"];

/** `DeviceFirmwareRequestResultStatus` */
export const DEVICE_FIRMWARE_REQUEST_RESULT_STATUS: readonly components["schemas"]["DeviceFirmwareRequestResultStatus"][] = ["accepted", "refused", "recorded"];

/** `DeviceFirmwareSuggestionState` */
export const DEVICE_FIRMWARE_SUGGESTION_STATE: readonly components["schemas"]["DeviceFirmwareSuggestionState"][] = ["suggested", "nothing_offered", "none_suitable", "several_suitable", "already_running", "catalog_unavailable"];

/** `DeviceImportFormat` */
export const DEVICE_IMPORT_FORMAT: readonly components["schemas"]["DeviceImportFormat"][] = ["csv", "xlsx"];

/** `DeviceImportRowOutcome` */
export const DEVICE_IMPORT_ROW_OUTCOME: readonly components["schemas"]["DeviceImportRowOutcome"][] = ["pending", "claimed", "stocked", "skipped", "failed", "error"];

/** `DeviceImportState` */
export const DEVICE_IMPORT_STATE: readonly components["schemas"]["DeviceImportState"][] = ["accepted", "running", "done", "interrupted"];

/** `DeviceModelFamily` */
export const DEVICE_MODEL_FAMILY: readonly components["schemas"]["DeviceModelFamily"][] = ["ap", "switch"];

/** `DeviceModelInterfaceKind` */
export const DEVICE_MODEL_INTERFACE_KIND: readonly components["schemas"]["DeviceModelInterfaceKind"][] = ["copper", "sfp", "qsfp", "console", "usb"];

/** `DeviceModelInterfacePoe` */
export const DEVICE_MODEL_INTERFACE_POE: readonly components["schemas"]["DeviceModelInterfacePoe"][] = ["802.3af", "802.3at", "802.3bt"];

/** `DeviceModelLayoutEntryKind` */
export const DEVICE_MODEL_LAYOUT_ENTRY_KIND: readonly components["schemas"]["DeviceModelLayoutEntryKind"][] = ["copper", "sfp", "qsfp"];

/** `DeviceModelMatchDeclaredFrom` */
export const DEVICE_MODEL_MATCH_DECLARED_FROM: readonly components["schemas"]["DeviceModelMatchDeclaredFrom"][] = ["record", "capabilities"];

/** `DeviceModelMatchKey` */
export const DEVICE_MODEL_MATCH_KEY: readonly components["schemas"]["DeviceModelMatchKey"][] = ["string", "ports"];

/** `DeviceModelMatchState` */
export const DEVICE_MODEL_MATCH_STATE: readonly components["schemas"]["DeviceModelMatchState"][] = ["recognised", "unrecognised"];

/** `DeviceModelPhysicalAntennas` */
export const DEVICE_MODEL_PHYSICAL_ANTENNAS: readonly components["schemas"]["DeviceModelPhysicalAntennas"][] = ["internal", "external"];

/** `DeviceModelPhysicalEnclosure` */
export const DEVICE_MODEL_PHYSICAL_ENCLOSURE: readonly components["schemas"]["DeviceModelPhysicalEnclosure"][] = ["indoor", "outdoor"];

/** `DeviceModelPhysicalMounts` */
export const DEVICE_MODEL_PHYSICAL_MOUNTS: readonly components["schemas"]["DeviceModelPhysicalMounts"][] = ["ceiling", "desk", "pole", "rack", "wall", "wall_box"];

/** `DeviceModelPowerPoeIn` */
export const DEVICE_MODEL_POWER_POE_IN: readonly components["schemas"]["DeviceModelPowerPoeIn"][] = ["802.3af", "802.3at", "802.3bt"];

/** `DeviceModelRadioBandBand` */
export const DEVICE_MODEL_RADIO_BAND_BAND: readonly components["schemas"]["DeviceModelRadioBandBand"][] = ["2.4", "5", "6"];

/** `DeviceModelRadioIotRadios` */
export const DEVICE_MODEL_RADIO_IOT_RADIOS: readonly components["schemas"]["DeviceModelRadioIotRadios"][] = ["ble", "thread", "zigbee"];

/** `DeviceModelRadioWifiGeneration` */
export const DEVICE_MODEL_RADIO_WIFI_GENERATION: readonly components["schemas"]["DeviceModelRadioWifiGeneration"][] = ["wifi4", "wifi5", "wifi6", "wifi6e", "wifi7"];

/** `DeviceOnboardingArrival` */
export const DEVICE_ONBOARDING_ARRIVAL: readonly components["schemas"]["DeviceOnboardingArrival"][] = ["heard_from", "not_heard_from"];

/** `DeviceOnboardingConfiguration` */
export const DEVICE_ONBOARDING_CONFIGURATION: readonly components["schemas"]["DeviceOnboardingConfiguration"][] = ["synchronized", "synchronizing", "behind", "offline", "carried", "unknown", "frozen"];

/** `DeviceOnboardingStep` */
export const DEVICE_ONBOARDING_STEP: readonly components["schemas"]["DeviceOnboardingStep"][] = ["not_known", "cds_points_elsewhere", "transfer_requested", "cds_points_here", "first_connection", "configuration_applied"];

/** `DeviceOnlineState` */
export const DEVICE_ONLINE_STATE: readonly components["schemas"]["DeviceOnlineState"][] = ["online", "offline", "unknown"];

/** `DevicePresence` */
export const DEVICE_PRESENCE: readonly components["schemas"]["DevicePresence"][] = ["present", "absent"];

/** `DevicePresenceReason` */
export const DEVICE_PRESENCE_REASON: readonly components["schemas"]["DevicePresenceReason"][] = ["never_seen", "class_mismatch"];

/** `DevicePushKind` */
export const DEVICE_PUSH_KIND: readonly components["schemas"]["DevicePushKind"][] = ["site_apply", "carried_seed", "carried_apply", "switch_ports", "refetch", "carried_record", "generated_record", "device_apply"];

/** `DevicePushState` */
export const DEVICE_PUSH_STATE: readonly components["schemas"]["DevicePushState"][] = ["sending", "accepted", "refused", "failed", "unknown", "stored"];

/** `DeviceReadinessHeldRecord` */
export const DEVICE_READINESS_HELD_RECORD: readonly components["schemas"]["DeviceReadinessHeldRecord"][] = ["carried_record", "generated_record"];

/** `DeviceReadinessReason` */
export const DEVICE_READINESS_REASON: readonly components["schemas"]["DeviceReadinessReason"][] = ["not_carried", "not_applied", "sent_not_confirmed", "stale", "unrecognised_source", "refused_by_cell_schema", "undeliverable_at_pin", "unqualified_pending_firmware", "reconciled", "not_on_cell", "held_on_cell", "refused_since_applied", "would_reboot", "seed_not_transmitting"];

/** `DeviceReadinessSeedWould` */
export const DEVICE_READINESS_SEED_WOULD: readonly components["schemas"]["DeviceReadinessSeedWould"][] = ["send", "write_record", "confirm", "skip_delivered", "skip_refused_by_cell_schema", "skip_no_digest", "skip_not_a_candidate"];

/** `DeviceRootPasswordHeld` */
export const DEVICE_ROOT_PASSWORD_HELD: readonly components["schemas"]["DeviceRootPasswordHeld"][] = ["absent", "empty", "default", "other", "no_document", "unread"];

/** `DeviceTypeSuggestionSource` */
export const DEVICE_TYPE_SUGGESTION_SOURCE: readonly components["schemas"]["DeviceTypeSuggestionSource"][] = ["mac_reporting"];

/** `DiagnosisOutcome` */
export const DIAGNOSIS_OUTCOME: readonly components["schemas"]["DiagnosisOutcome"][] = ["answered", "declined"];

/** `DocumentDifferenceState` */
export const DOCUMENT_DIFFERENCE_STATE: readonly components["schemas"]["DocumentDifferenceState"][] = ["added", "removed", "changed"];

/** `DocumentDifferenceWithheld` */
export const DOCUMENT_DIFFERENCE_WITHHELD: readonly components["schemas"]["DocumentDifferenceWithheld"][] = ["secret", "unclassified"];

/** `DocumentNotSatisfiedDocument` */
export const DOCUMENT_NOT_SATISFIED_DOCUMENT: readonly components["schemas"]["DocumentNotSatisfiedDocument"][] = ["held", "refetch", "carried"];

/** `DocumentNotSatisfiedRevalidation` */
export const DOCUMENT_NOT_SATISFIED_REVALIDATION: readonly components["schemas"]["DocumentNotSatisfiedRevalidation"][] = ["passed", "failed", "skipped", "unavailable"];

/** `DocumentNotSatisfiedTriggers` */
export const DOCUMENT_NOT_SATISFIED_TRIGGERS: readonly components["schemas"]["DocumentNotSatisfiedTriggers"][] = ["pin", "vocabulary", "stated"];

/** `DocumentWithheldLeafClass` */
export const DOCUMENT_WITHHELD_LEAF_CLASS: readonly components["schemas"]["DocumentWithheldLeafClass"][] = ["secret", "unclassified"];

/** `DomainChallengeRecordType` */
export const DOMAIN_CHALLENGE_RECORD_TYPE: readonly components["schemas"]["DomainChallengeRecordType"][] = ["TXT"];

/** `EstateHardwareBridgeBasis` */
export const ESTATE_HARDWARE_BRIDGE_BASIS: readonly components["schemas"]["EstateHardwareBridgeBasis"][] = ["release_table", "observed_devices"];

/** `EstateHardwareCellCopy` */
export const ESTATE_HARDWARE_CELL_COPY: readonly components["schemas"]["EstateHardwareCellCopy"][] = ["current", "stale", "none"];

/** `EstateHardwarePinState` */
export const ESTATE_HARDWARE_PIN_STATE: readonly components["schemas"]["EstateHardwarePinState"][] = ["rule", "no_rule", "not_asked"];

/** `EstateHardwareRowFamily` */
export const ESTATE_HARDWARE_ROW_FAMILY: readonly components["schemas"]["EstateHardwareRowFamily"][] = ["ap", "switch", "unknown"];

/** `EstateHardwareUnknownWhat` */
export const ESTATE_HARDWARE_UNKNOWN_WHAT: readonly components["schemas"]["EstateHardwareUnknownWhat"][] = ["family", "model", "firmware"];

/** `ExitReadingOutcome` */
export const EXIT_READING_OUTCOME: readonly components["schemas"]["ExitReadingOutcome"][] = ["not_read_yet", "cell_not_read", "sent_its_own_since", "not_running_held", "cell_did_not_take", "holds_other_document", "record_disagrees", "unmeasured_build", "already_asked", "disagrees", "unread"];

/** `ExitReadingReconcileAgain` */
export const EXIT_READING_RECONCILE_AGAIN: readonly components["schemas"]["ExitReadingReconcileAgain"][] = ["helps", "cannot", "wait"];

/** `FastRoamingRemovalCost` */
export const FAST_ROAMING_REMOVAL_COST: readonly components["schemas"]["FastRoamingRemovalCost"][] = ["none_on_air", "fast_transition_lost", "unknown"];

/** `FirmwareDeliveryDeviceReadingComparison` */
export const FIRMWARE_DELIVERY_DEVICE_READING_COMPARISON: readonly components["schemas"]["FirmwareDeliveryDeviceReadingComparison"][] = ["matches", "differs", "not_comparable"];

/** `FirmwareDeliveryDeviceReadingLiveness` */
export const FIRMWARE_DELIVERY_DEVICE_READING_LIVENESS: readonly components["schemas"]["FirmwareDeliveryDeviceReadingLiveness"][] = ["online", "offline", "unknown"];

/** `FirmwareDeliveryNextStep` */
export const FIRMWARE_DELIVERY_NEXT_STEP: readonly components["schemas"]["FirmwareDeliveryNextStep"][] = ["force_available", "ask_provider", "wait_for_reading", "report_firmware", "none"];

/** `FirmwareDeliveryReason` */
export const FIRMWARE_DELIVERY_REASON: readonly components["schemas"]["FirmwareDeliveryReason"][] = ["entry_unknown", "entry_not_fleet_ready", "entry_not_vendor_access_point", "outside_staging", "site_unplaced", "device_not_at_site", "device_unread", "compatible_mismatch", "source_build_unread", "no_rollback_target", "delivery_in_progress", "digest_mismatch", "fetch_redirected", "placement_moved", "orbit_unavailable", "sender_refused", "delivery_blocked", "override_not_applicable", "short_body_unread", "keep_redirector_unrecorded", "canary_unconfirmed", "firmware_delivery_refused", "not_handed_over", "controller_refused", "did_not_return", "firmware_line_mismatch", "upgrade_failed", "root_digest_mismatch", "firmware_delivery_failed", "handoff_unanswered", "handoff_conflict", "operation_not_found", "orbit_unreadable", "state_unrecognised", "outcome_unknown"];

/** `FirmwareDeliveryState` */
export const FIRMWARE_DELIVERY_STATE: readonly components["schemas"]["FirmwareDeliveryState"][] = ["handing_over", "refused", "accepted", "in_progress", "delivered", "failed", "unknown"];

/** `FirmwareDeliveryStepName` */
export const FIRMWARE_DELIVERY_STEP_NAME: readonly components["schemas"]["FirmwareDeliveryStepName"][] = ["accepted", "command_committed", "controller_answered", "device_returned", "confirmed", "refused", "stopped", "unrecognised"];

/** `FirmwareVendorLine` */
export const FIRMWARE_VENDOR_LINE: readonly components["schemas"]["FirmwareVendorLine"][] = ["ap_nos", "tip", "unrecognised"];

/** `FrozenAccessPointAct` */
export const FROZEN_ACCESS_POINT_ACT: readonly components["schemas"]["FrozenAccessPointAct"][] = ["attached", "kept"];

/** `FrozenAccessPointMissing` */
export const FROZEN_ACCESS_POINT_MISSING: readonly components["schemas"]["FrozenAccessPointMissing"][] = ["pin", "vocabulary", "pin_and_vocabulary"];

/** `GeneratedConfigIntentKind` */
export const GENERATED_CONFIG_INTENT_KIND: readonly components["schemas"]["GeneratedConfigIntentKind"][] = ["venue", "access_point", "switch"];

/** `GeneratedConfigIntentSnapshot` */
export const GENERATED_CONFIG_INTENT_SNAPSHOT: readonly components["schemas"]["GeneratedConfigIntentSnapshot"][] = ["kept", "none"];

/** `GeneratedConfigPushState` */
export const GENERATED_CONFIG_PUSH_STATE: readonly components["schemas"]["GeneratedConfigPushState"][] = ["pending", "running", "done", "failed", "unknown"];

/** `GeneratedConfigTargetKind` */
export const GENERATED_CONFIG_TARGET_KIND: readonly components["schemas"]["GeneratedConfigTargetKind"][] = ["venue", "device"];

/** `GuestSessionOpenedBy` */
export const GUEST_SESSION_OPENED_BY: readonly components["schemas"]["GuestSessionOpenedBy"][] = ["start", "interim"];

/** `GuestSessionStopReason` */
export const GUEST_SESSION_STOP_REASON: readonly components["schemas"]["GuestSessionStopReason"][] = ["stop", "stale", "superseded"];

/** `ImportRowVerdict` */
export const IMPORT_ROW_VERDICT: readonly components["schemas"]["ImportRowVerdict"][] = ["ok", "stock", "skip", "error"];

/** `IntentChangeKind` */
export const INTENT_CHANGE_KIND: readonly components["schemas"]["IntentChangeKind"][] = ["added", "removed", "changed"];

/** `IntentChangeObject` */
export const INTENT_CHANGE_OBJECT: readonly components["schemas"]["IntentChangeObject"][] = ["site", "network", "radio", "ssh_key", "generated_ssh_key", "radio_overlay", "leds", "port", "switch_setting"];

/** `IntentSealedComparison` */
export const INTENT_SEALED_COMPARISON: readonly components["schemas"]["IntentSealedComparison"][] = ["same", "different", "unreadable"];

/** `IntentSealedItem` */
export const INTENT_SEALED_ITEM: readonly components["schemas"]["IntentSealedItem"][] = ["material", "radius_secret", "admin_password"];

/** `InterfaceChangeKind` */
export const INTERFACE_CHANGE_KIND: readonly components["schemas"]["InterfaceChangeKind"][] = ["added", "removed"];

/** `InvitationAcceptStepStep` */
export const INVITATION_ACCEPT_STEP_STEP: readonly components["schemas"]["InvitationAcceptStepStep"][] = ["set_password", "sign_in", "new_password", "existing_password"];

/** `InvitationDeliveryDetailState` */
export const INVITATION_DELIVERY_DETAIL_STATE: readonly components["schemas"]["InvitationDeliveryDetailState"][] = ["given", "none_given", "not_read"];

/** `InvitationDeliveryStatus` */
export const INVITATION_DELIVERY_STATUS: readonly components["schemas"]["InvitationDeliveryStatus"][] = ["accepted", "delivered", "failed"];

/** `KilnCatalogReadState` */
export const KILN_CATALOG_READ_STATE: readonly components["schemas"]["KilnCatalogReadState"][] = ["read", "unavailable"];

/** `LinkEndKind` */
export const LINK_END_KIND: readonly components["schemas"]["LinkEndKind"][] = ["claimed", "planned"];

/** `LinkRole` */
export const LINK_ROLE: readonly components["schemas"]["LinkRole"][] = ["uplink", "stack"];

/** `LocationKind` */
export const LOCATION_KIND: readonly components["schemas"]["LocationKind"][] = ["room", "closet", "rack", "outdoor", "unit", "common_area", "store", "office"];

/** `LocationMount` */
export const LOCATION_MOUNT: readonly components["schemas"]["LocationMount"][] = ["wall", "ceiling", "in_ceiling", "pole", "desk"];

/** `LogoOnDark` */
export const LOGO_ON_DARK: readonly components["schemas"]["LogoOnDark"][] = ["as-is", "white"];

/** `MessagingChannel` */
export const MESSAGING_CHANNEL: readonly components["schemas"]["MessagingChannel"][] = ["email", "sms"];

/** `MessagingProviderKind` */
export const MESSAGING_PROVIDER_KIND: readonly components["schemas"]["MessagingProviderKind"][] = ["smtp", "resend", "twilio"];

/** `NetworkChangeKind` */
export const NETWORK_CHANGE_KIND: readonly components["schemas"]["NetworkChangeKind"][] = ["added", "changed", "unchanged", "removed", "narrowed"];

/** `NetworkDifferenceChange` */
export const NETWORK_DIFFERENCE_CHANGE: readonly components["schemas"]["NetworkDifferenceChange"][] = ["stops_broadcasting", "new", "changes", "unchanged"];

/** `NetworkField` */
export const NETWORK_FIELD: readonly components["schemas"]["NetworkField"][] = ["ssid", "security.mode", "security.wpa3", "security.psk", "security.radius.server", "security.radius.port", "security.radius.secret", "security.radius.accounting.server", "security.radius.accounting.port", "security.radius.accounting.secret", "security.radius.accounting.interval", "vlan", "bands", "hidden", "isolate_clients", "isolate_to_gateway", "isolation_allowed_macs", "client_limit", "rate_limit.ingress_mbps", "rate_limit.egress_mbps", "fast_roaming", "unicast_conversion", "neighbour_reporting"];

/** `NetworkFieldsPsk` */
export const NETWORK_FIELDS_PSK: readonly components["schemas"]["NetworkFieldsPsk"][] = ["<<REDACTED:key>>"];

/** `NetworkFieldsRadiusSecret` */
export const NETWORK_FIELDS_RADIUS_SECRET: readonly components["schemas"]["NetworkFieldsRadiusSecret"][] = ["<<REDACTED:secret>>"];

/** `NetworkFieldsSecurityMode` */
export const NETWORK_FIELDS_SECURITY_MODE: readonly components["schemas"]["NetworkFieldsSecurityMode"][] = ["open", "psk", "enterprise"];

/** `NetworkFieldsWpa3` */
export const NETWORK_FIELDS_WPA3: readonly components["schemas"]["NetworkFieldsWpa3"][] = ["off", "transition", "only"];

/** `NetworkReachAccessPointCeilingSource` */
export const NETWORK_REACH_ACCESS_POINT_CEILING_SOURCE: readonly components["schemas"]["NetworkReachAccessPointCeilingSource"][] = ["fallback", "recorded"];

/** `NetworkSecurityMaterialRevealHolds` */
export const NETWORK_SECURITY_MATERIAL_REVEAL_HOLDS: readonly components["schemas"]["NetworkSecurityMaterialRevealHolds"][] = ["material", "none_for_mode", "none_stored"];

/** `OrgCreateRequest.org_type` */
export const ORG_CREATE_REQUEST_ORG_TYPE: readonly NonNullable<components["schemas"]["OrgCreateRequest"]["org_type"]>[] = ["provider", "reseller", "business"];

/** `OrgOrgType` */
export const ORG_ORG_TYPE: readonly components["schemas"]["OrgOrgType"][] = ["platform", "provider", "reseller", "business"];

/** `OrgUpdateRequest.org_type` */
export const ORG_UPDATE_REQUEST_ORG_TYPE: readonly NonNullable<components["schemas"]["OrgUpdateRequest"]["org_type"]>[] = ["provider", "reseller", "business"];

/** `OwedWithdrawalAct` */
export const OWED_WITHDRAWAL_ACT: readonly components["schemas"]["OwedWithdrawalAct"][] = ["org.delete", "customer.delete", "site.delete"];

/** `OwedWithdrawalOutcome` */
export const OWED_WITHDRAWAL_OUTCOME: readonly components["schemas"]["OwedWithdrawalOutcome"][] = ["owed", "unreachable", "refused", "conflict", "withdrawn"];

/** `PanImportVerdict` */
export const PAN_IMPORT_VERDICT: readonly components["schemas"]["PanImportVerdict"][] = ["create", "held_without_vlan", "name_missing", "text_too_long", "status_unreadable", "expiry_unreadable", "vlan_unreadable", "no_passphrase", "passphrase_length", "passphrase_in_use"];

/** `PanStatus` */
export const PAN_STATUS: readonly components["schemas"]["PanStatus"][] = ["active", "expired", "disabled"];

/** `PlacementRequestOutcome` */
export const PLACEMENT_REQUEST_OUTCOME: readonly components["schemas"]["PlacementRequestOutcome"][] = ["placed", "awaiting", "unreachable", "refused", "conflict"];

/** `PlanDeviceRecordAction` */
export const PLAN_DEVICE_RECORD_ACTION: readonly components["schemas"]["PlanDeviceRecordAction"][] = ["write", "exists", "not_written"];

/** `PlanDocumentAction` */
export const PLAN_DOCUMENT_ACTION: readonly components["schemas"]["PlanDocumentAction"][] = ["create", "save", "detach"];

/** `PlanDocumentRefTargetKind` */
export const PLAN_DOCUMENT_REF_TARGET_KIND: readonly components["schemas"]["PlanDocumentRefTargetKind"][] = ["venue", "device"];

/** `PlanDocumentTargetKind` */
export const PLAN_DOCUMENT_TARGET_KIND: readonly components["schemas"]["PlanDocumentTargetKind"][] = ["venue", "device"];

/** `PlanLEDOverrideAct` */
export const PLAN_LED_OVERRIDE_ACT: readonly components["schemas"]["PlanLEDOverrideAct"][] = ["attach", "replace", "detach"];

/** `PlanLEDsSource` */
export const PLAN_LE_DS_SOURCE: readonly components["schemas"]["PlanLEDsSource"][] = ["site", "default"];

/** `PlanTimeServersSource` */
export const PLAN_TIME_SERVERS_SOURCE: readonly components["schemas"]["PlanTimeServersSource"][] = ["site", "default"];

/** `PlannedDeviceFamily` */
export const PLANNED_DEVICE_FAMILY: readonly components["schemas"]["PlannedDeviceFamily"][] = ["ap", "switch"];

/** `PlannerLinkUnavailable` */
export const PLANNER_LINK_UNAVAILABLE: readonly components["schemas"]["PlannerLinkUnavailable"][] = ["azimuth_not_named", "no_provider_organization"];

/** `PoEPriority` */
export const PO_E_PRIORITY: readonly components["schemas"]["PoEPriority"][] = ["critical", "high", "medium", "low"];

/** `PoeCycleResultOutcome` */
export const POE_CYCLE_RESULT_OUTCOME: readonly components["schemas"]["PoeCycleResultOutcome"][] = ["cycled", "restored", "stranded", "not_sent"];

/** `PoeCycleVia` */
export const POE_CYCLE_VIA: readonly components["schemas"]["PoeCycleVia"][] = ["lldp", "fdb", "named"];

/** `PortIntentKind` */
export const PORT_INTENT_KIND: readonly components["schemas"]["PortIntentKind"][] = ["claimed", "planned"];

/** `PortIntentSetFirmwareQualified` */
export const PORT_INTENT_SET_FIRMWARE_QUALIFIED: readonly components["schemas"]["PortIntentSetFirmwareQualified"][] = ["qualified", "unqualified", "unknown"];

/** `PortIntentSetUplinkAbsent` */
export const PORT_INTENT_SET_UPLINK_ABSENT: readonly components["schemas"]["PortIntentSetUplinkAbsent"][] = ["none_named", "conflict", "no_report", "unanswered"];

/** `PortReachLineAnswer` */
export const PORT_REACH_LINE_ANSWER: readonly components["schemas"]["PortReachLineAnswer"][] = ["agree", "asks", "refuses", "unanswered"];

/** `PortReachLineMismatch` */
export const PORT_REACH_LINE_MISMATCH: readonly components["schemas"]["PortReachLineMismatch"][] = ["tagged_missing", "tagged_untagged", "untagged_missing", "port_disabled", "pan_vlans_missing", "untagged_moved", "uplink_vlans_missing", "uplink_untagged_path_missing"];

/** `PortReachLineNeed` */
export const PORT_REACH_LINE_NEED: readonly components["schemas"]["PortReachLineNeed"][] = ["tagged", "untagged", "port", "pan_vlans", "uplink"];

/** `PortVoiceDetectVoice` */
export const PORT_VOICE_DETECT_VOICE: readonly components["schemas"]["PortVoiceDetectVoice"][] = ["oui", "lldp"];

/** `PortVoiceIntentDetectVoice` */
export const PORT_VOICE_INTENT_DETECT_VOICE: readonly components["schemas"]["PortVoiceIntentDetectVoice"][] = ["oui", "lldp"];

/** `PortVoiceIntentMode` */
export const PORT_VOICE_INTENT_MODE: readonly components["schemas"]["PortVoiceIntentMode"][] = ["none", "manual", "auto"];

/** `PortVoiceMode` */
export const PORT_VOICE_MODE: readonly components["schemas"]["PortVoiceMode"][] = ["none", "manual", "auto"];

/** `PortalAuthMethod` */
export const PORTAL_AUTH_METHOD: readonly components["schemas"]["PortalAuthMethod"][] = ["click_through", "voucher", "email_code"];

/** `PortalMode` */
export const PORTAL_MODE: readonly components["schemas"]["PortalMode"][] = ["uam"];

/** `ProblemReason` */
export const PROBLEM_REASON: readonly components["schemas"]["ProblemReason"][] = ["not_implemented", "invalid", "rejected", "not_found", "conflict", "stale", "unauthenticated", "forbidden", "rate_limited", "unresolved", "no_venue", "no_hardware", "no_admin_password", "no_generated_ssh_key", "moving", "unconfirmed", "no_console", "carried", "unmodelled_divergence", "mixed_port_vocabulary", "unmodelled_security_mode", "no_resident_radius", "unmodelled_radio_overlay", "upstream", "outcome_unknown", "identity_refused", "dependency_unconfigured", "no_geocoding_provider", "link_refused", "no_identity_provider", "provider_org_pending", "staff_method", "no_email_provider", "no_model_provider", "unqualified_firmware", "firmware_line_change", "firmware_delivery_in_flight", "firmware_delivery_not_handed_over", "site_upgrade_run_in_progress", "site_upgrade_list_refused", "unpinned_firmware", "no_gateway_record", "passphrase_in_use", "gateway_not_enabled", "apply_stopped", "cell_check_failed", "captive_unmeasured_build", "no_guest_aaa", "open_network_bound", "held_connections_full", "apply_in_flight", "import_in_flight", "token_limit", "report_relay_unavailable", "release_waiting", "release_offline", "release_replaced", "internal"];

/** `ProviderOrgStateState` */
export const PROVIDER_ORG_STATE_STATE: readonly components["schemas"]["ProviderOrgStateState"][] = ["pending", "created", "failed"];

/** `RadioBusyState` */
export const RADIO_BUSY_STATE: readonly components["schemas"]["RadioBusyState"][] = ["reported", "cumulative", "not_reported"];

/** `RadioChangeKind` */
export const RADIO_CHANGE_KIND: readonly components["schemas"]["RadioChangeKind"][] = ["added", "changed", "unchanged", "removed"];

/** `RadioField` */
export const RADIO_FIELD: readonly components["schemas"]["RadioField"][] = ["channel", "channel_width", "mode", "country", "tx_power", "allow_dfs", "valid_channels", "minimum_rate_mbps", "legacy_rates", "maximum_clients", "multiple_bssid"];

/** `RadioIntentEntry.channel_width` */
export const RADIO_INTENT_ENTRY_CHANNEL_WIDTH: readonly NonNullable<components["schemas"]["RadioIntentEntry"]["channel_width"]>[] = [20, 40, 80, 160, 320];

/** `RadioIntentEntry.minimum_rate_mbps` */
export const RADIO_INTENT_ENTRY_MINIMUM_RATE_MBPS: readonly NonNullable<components["schemas"]["RadioIntentEntry"]["minimum_rate_mbps"]>[] = [6, 9, 12, 18, 24, 36, 48, 54];

/** `RadioIntentMinimumRateMbps` */
export const RADIO_INTENT_MINIMUM_RATE_MBPS: readonly components["schemas"]["RadioIntentMinimumRateMbps"][] = [6, 9, 12, 18, 24, 36, 48, 54];

/** `RadioMode` */
export const RADIO_MODE: readonly components["schemas"]["RadioMode"][] = ["HT", "VHT", "HE", "EHT"];

/** `RadioOverlayEntry.channel_width` */
export const RADIO_OVERLAY_ENTRY_CHANNEL_WIDTH: readonly NonNullable<components["schemas"]["RadioOverlayEntry"]["channel_width"]>[] = [20, 40, 80, 160, 320];

/** `RadioSource` */
export const RADIO_SOURCE: readonly components["schemas"]["RadioSource"][] = ["site", "access_point"];

/** `RadiusVlanPathState` */
export const RADIUS_VLAN_PATH_STATE: readonly components["schemas"]["RadiusVlanPathState"][] = ["found", "none", "unknown"];

/** `RebootPredictionAnswer` */
export const REBOOT_PREDICTION_ANSWER: readonly components["schemas"]["RebootPredictionAnswer"][] = ["reboots", "stays", "unknown"];

/** `RebootPredictionCountryStored` */
export const REBOOT_PREDICTION_COUNTRY_STORED: readonly components["schemas"]["RebootPredictionCountryStored"][] = ["stores", "already_held", "not_stored"];

/** `ReconcilePlanAdministrativePassword` */
export const RECONCILE_PLAN_ADMINISTRATIVE_PASSWORD: readonly components["schemas"]["ReconcilePlanAdministrativePassword"][] = ["set", "replaced", "unchanged"];

/** `RecordOutcomeState` */
export const RECORD_OUTCOME_STATE: readonly components["schemas"]["RecordOutcomeState"][] = ["stored", "failed", "refused", "unknown"];

/** `RegulatoryCountry` */
export const REGULATORY_COUNTRY: readonly components["schemas"]["RegulatoryCountry"][] = ["AD", "AE", "AF", "AI", "AL", "AM", "AN", "AR", "AS", "AT", "AU", "AW", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BL", "BM", "BN", "BO", "BR", "BS", "BT", "BY", "BZ", "CA", "CF", "CH", "CI", "CL", "CN", "CO", "CR", "CU", "CX", "CY", "CZ", "DE", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "ES", "ET", "FI", "FM", "FR", "GB", "GD", "GE", "GF", "GH", "GL", "GP", "GR", "GT", "GU", "GY", "HK", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IN", "IR", "IS", "IT", "JM", "JO", "JP", "KE", "KH", "KN", "KP", "KR", "KW", "KY", "KZ", "LB", "LC", "LI", "LK", "LS", "LT", "LU", "LV", "MA", "MC", "MD", "ME", "MF", "MH", "MK", "MN", "MO", "MP", "MQ", "MR", "MT", "MU", "MV", "MW", "MX", "MY", "NG", "NI", "NL", "NO", "NP", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PR", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SE", "SG", "SI", "SK", "SN", "SR", "SV", "TC", "TD", "TG", "TH", "TN", "TR", "TT", "TW", "TZ", "UA", "UG", "US", "UY", "UZ", "VC", "VE", "VI", "VN", "VU", "WF", "WS", "YT", "ZA", "ZW"];

/** `RemovedFateLineAnswer` */
export const REMOVED_FATE_LINE_ANSWER: readonly components["schemas"]["RemovedFateLineAnswer"][] = ["on", "running_not_read", "priority_below_32768"];

/** `ReportError.source` */
export const REPORT_ERROR_SOURCE: readonly NonNullable<components["schemas"]["ReportError"]["source"]>[] = ["boundary", "error", "unhandledrejection"];

/** `ReportRequest.kind` */
export const REPORT_REQUEST_KIND: readonly NonNullable<components["schemas"]["ReportRequest"]["kind"]>[] = ["bug", "feature"];

/** `RestoreDroppedReason` */
export const RESTORE_DROPPED_REASON: readonly components["schemas"]["RestoreDroppedReason"][] = ["device_not_at_site", "location_gone", "portal_gone", "generated_ssh_key_not_kept", "per_unit_passphrases_not_kept", "switch_setting_not_held"];

/** `RestoreVerdictReason` */
export const RESTORE_VERDICT_REASON: readonly components["schemas"]["RestoreVerdictReason"][] = ["schema_moved", "narrowed", "not_all_restored", "base_or_generator_moved", "no_plan"];

/** `Role` */
export const ROLE: readonly components["schemas"]["Role"][] = ["owner", "admin", "operator", "viewer", "guest_desk", "unit_manager"];

/** `ScopeType` */
export const SCOPE_TYPE: readonly components["schemas"]["ScopeType"][] = ["org", "customer", "site"];

/** `SearchHitDeviceClass` */
export const SEARCH_HIT_DEVICE_CLASS: readonly components["schemas"]["SearchHitDeviceClass"][] = ["ap", "switch"];

/** `SearchHitKind` */
export const SEARCH_HIT_KIND: readonly components["schemas"]["SearchHitKind"][] = ["claimed_device", "planned_device", "radio_address", "customer", "site", "network", "vlan_name", "org"];

/** `SearchHitRadioRule` */
export const SEARCH_HIT_RADIO_RULE: readonly components["schemas"]["SearchHitRadioRule"][] = ["reported", "derived"];

/** `SearchHitType` */
export const SEARCH_HIT_TYPE: readonly components["schemas"]["SearchHitType"][] = ["device", "customer", "site", "network", "org"];

/** `SearchResultsNotSearched` */
export const SEARCH_RESULTS_NOT_SEARCHED: readonly components["schemas"]["SearchResultsNotSearched"][] = ["access_point_name", "connected_device_model", "client_address", "device_address"];

/** `SecurityMode` */
export const SECURITY_MODE: readonly components["schemas"]["SecurityMode"][] = ["open", "psk", "enterprise", "mpsk", "passpoint"];

/** `ServedDocumentSource` */
export const SERVED_DOCUMENT_SOURCE: readonly components["schemas"]["ServedDocumentSource"][] = ["venue_configuration", "its_own_generated_configuration", "its_own_carried_configuration_through_a_protective_attachment", "unchanged_by_this_act", "its_frozen_configuration_as_already_served"];

/** `ServicePrincipalGrantRole` */
export const SERVICE_PRINCIPAL_GRANT_ROLE: readonly components["schemas"]["ServicePrincipalGrantRole"][] = ["admin", "operator", "viewer", "radio_runtime"];

/** `ServicePrincipalGrantScopeType` */
export const SERVICE_PRINCIPAL_GRANT_SCOPE_TYPE: readonly components["schemas"]["ServicePrincipalGrantScopeType"][] = ["org", "customer", "site"];

/** `ServicePrincipalScopeType` */
export const SERVICE_PRINCIPAL_SCOPE_TYPE: readonly components["schemas"]["ServicePrincipalScopeType"][] = ["org", "customer"];

/** `ServicePrincipalTokenState` */
export const SERVICE_PRINCIPAL_TOKEN_STATE: readonly components["schemas"]["ServicePrincipalTokenState"][] = ["live", "expired", "revoked", "disabled"];

/** `SignInDoor` */
export const SIGN_IN_DOOR: readonly components["schemas"]["SignInDoor"][] = ["password", "provider"];

/** `SignalFiguresSeriesKey` */
export const SIGNAL_FIGURES_SERIES_KEY: readonly components["schemas"]["SignalFiguresSeriesKey"][] = ["good", "fair", "poor"];

/** `SiteAffiliation` */
export const SITE_AFFILIATION: readonly components["schemas"]["SiteAffiliation"][] = ["franchised", "managed", "corporate", "independent", "other"];

/** `SiteCellRemovalResolvesFrom` */
export const SITE_CELL_REMOVAL_RESOLVES_FROM: readonly components["schemas"]["SiteCellRemovalResolvesFrom"][] = ["orbit"];

/** `SiteCellSource` */
export const SITE_CELL_SOURCE: readonly components["schemas"]["SiteCellSource"][] = ["manual", "orbit"];

/** `SiteCellSummarySource` */
export const SITE_CELL_SUMMARY_SOURCE: readonly components["schemas"]["SiteCellSummarySource"][] = ["manual", "orbit"];

/** `SiteConvergenceReason` */
export const SITE_CONVERGENCE_REASON: readonly components["schemas"]["SiteConvergenceReason"][] = ["placement", "no_access_points"];

/** `SiteEffectiveVerticalKey` */
export const SITE_EFFECTIVE_VERTICAL_KEY: readonly components["schemas"]["SiteEffectiveVerticalKey"][] = ["hospitality", "senior", "mdu", "corporate", "retail"];

/** `SiteEffectiveVerticalSource` */
export const SITE_EFFECTIVE_VERTICAL_SOURCE: readonly components["schemas"]["SiteEffectiveVerticalSource"][] = ["explicit", "chain", "none"];

/** `SiteFirmwareMatchState` */
export const SITE_FIRMWARE_MATCH_STATE: readonly components["schemas"]["SiteFirmwareMatchState"][] = ["matched", "none", "unknown"];

/** `SiteGatewayAppliedChangeAction` */
export const SITE_GATEWAY_APPLIED_CHANGE_ACTION: readonly components["schemas"]["SiteGatewayAppliedChangeAction"][] = ["create", "edit", "skip"];

/** `SiteGatewayAppliedChangeOutcome` */
export const SITE_GATEWAY_APPLIED_CHANGE_OUTCOME: readonly components["schemas"]["SiteGatewayAppliedChangeOutcome"][] = ["written", "already_so", "not_reached", "unknown"];

/** `SiteGatewayApplyPartialStop` */
export const SITE_GATEWAY_APPLY_PARTIAL_STOP: readonly components["schemas"]["SiteGatewayApplyPartialStop"][] = ["time_left", "stale", "no_answer"];

/** `SiteGatewayChangeAction` */
export const SITE_GATEWAY_CHANGE_ACTION: readonly components["schemas"]["SiteGatewayChangeAction"][] = ["create", "edit", "skip"];

/** `SiteGatewayTunnelState` */
export const SITE_GATEWAY_TUNNEL_STATE: readonly components["schemas"]["SiteGatewayTunnelState"][] = ["reported", "unknown"];

/** `SiteGeneratedSSHKeyStateState` */
export const SITE_GENERATED_SSH_KEY_STATE_STATE: readonly components["schemas"]["SiteGeneratedSSHKeyStateState"][] = ["held", "removed", "none"];

/** `SiteGuestAccess` */
export const SITE_GUEST_ACCESS: readonly components["schemas"]["SiteGuestAccess"][] = ["none", "uam"];

/** `SiteHealthDevicesCoverage` */
export const SITE_HEALTH_DEVICES_COVERAGE: readonly components["schemas"]["SiteHealthDevicesCoverage"][] = ["counted", "not_read", "unplaced"];

/** `SiteHealthRowStatus` */
export const SITE_HEALTH_ROW_STATUS: readonly components["schemas"]["SiteHealthRowStatus"][] = ["ok", "no_cell", "no_venue", "failed"];

/** `SiteHostClass` */
export const SITE_HOST_CLASS: readonly components["schemas"]["SiteHostClass"][] = ["station", "wired_behind_access_point", "wired", "in_transit"];

/** `SiteHostIPSource` */
export const SITE_HOST_IP_SOURCE: readonly components["schemas"]["SiteHostIPSource"][] = ["access_point_clients_table", "access_point_association"];

/** `SiteHostPlaceKind` */
export const SITE_HOST_PLACE_KIND: readonly components["schemas"]["SiteHostPlaceKind"][] = ["edge", "access_point", "uplink", "switch_link", "aggregate"];

/** `SiteHostPortKind` */
export const SITE_HOST_PORT_KIND: readonly components["schemas"]["SiteHostPortKind"][] = ["edge", "access_point", "uplink", "switch_link", "aggregate"];

/** `SiteHostSwitchState` */
export const SITE_HOST_SWITCH_STATE: readonly components["schemas"]["SiteHostSwitchState"][] = ["reported", "no_table", "no_report", "unreadable", "unanswered", "offline", "unknown"];

/** `SitePlaceSource` */
export const SITE_PLACE_SOURCE: readonly components["schemas"]["SitePlaceSource"][] = ["google", "pin"];

/** `SitePlacementSummaryOutcome` */
export const SITE_PLACEMENT_SUMMARY_OUTCOME: readonly components["schemas"]["SitePlacementSummaryOutcome"][] = ["placed", "awaiting", "unreachable", "refused", "conflict"];

/** `SiteRegion` */
export const SITE_REGION: readonly components["schemas"]["SiteRegion"][] = ["CA-AB", "CA-BC", "CA-MB", "CA-NB", "CA-NL", "CA-NS", "CA-NT", "CA-NU", "CA-ON", "CA-PE", "CA-QC", "CA-SK", "CA-YT", "US-AK", "US-AL", "US-AR", "US-AZ", "US-CA", "US-CO", "US-CT", "US-DC", "US-DE", "US-FL", "US-GA", "US-HI", "US-IA", "US-ID", "US-IL", "US-IN", "US-KS", "US-KY", "US-LA", "US-MA", "US-MD", "US-ME", "US-MI", "US-MN", "US-MO", "US-MS", "US-MT", "US-NC", "US-ND", "US-NE", "US-NH", "US-NJ", "US-NM", "US-NV", "US-NY", "US-OH", "US-OK", "US-OR", "US-PA", "US-RI", "US-SC", "US-SD", "US-TN", "US-TX", "US-UT", "US-VA", "US-VT", "US-WA", "US-WI", "US-WV", "US-WY"];

/** `SiteUpdateRequest.guest_access` */
export const SITE_UPDATE_REQUEST_GUEST_ACCESS: readonly NonNullable<components["schemas"]["SiteUpdateRequest"]["guest_access"]>[] = ["none", "uam"];

/** `SiteUpgradeLeftOutReason` */
export const SITE_UPGRADE_LEFT_OUT_REASON: readonly components["schemas"]["SiteUpgradeLeftOutReason"][] = ["catalog_unread", "needs_acceptance", "more_than_one_suitable", "no_suitable_candidate", "runs_it_already", "link_mode_ssid", "document_unread", "offline", "no_gateway_record", "delivery_in_flight"];

/** `SiteUpgradeNotBack` */
export const SITE_UPGRADE_NOT_BACK: readonly components["schemas"]["SiteUpgradeNotBack"][] = ["offline", "firmware_differs", "configuration_behind"];

/** `SiteUpgradeRunDeviceState` */
export const SITE_UPGRADE_RUN_DEVICE_STATE: readonly components["schemas"]["SiteUpgradeRunDeviceState"][] = ["waiting", "not_reached", "skipped", "handing_over", "refused", "accepted", "in_progress", "delivered", "failed", "unknown"];

/** `SiteUpgradeRunState` */
export const SITE_UPGRADE_RUN_STATE: readonly components["schemas"]["SiteUpgradeRunState"][] = ["running", "stopped", "completed"];

/** `SiteUpgradeSkipReason` */
export const SITE_UPGRADE_SKIP_REASON: readonly components["schemas"]["SiteUpgradeSkipReason"][] = ["not_at_site", "offline", "no_gateway_record", "candidate_changed", "delivery_in_flight", "device_refused"];

/** `SiteUpgradeStopReason` */
export const SITE_UPGRADE_STOP_REASON: readonly components["schemas"]["SiteUpgradeStopReason"][] = ["operator_stopped", "approver_lost_reach", "delivery_failed", "delivery_refused", "delivery_not_handed_over", "delivery_unknown", "did_not_come_back", "catalog_unreadable", "cell_unreadable"];

/** `SsidOnAirComparison` */
export const SSID_ON_AIR_COMPARISON: readonly components["schemas"]["SsidOnAirComparison"][] = ["matches", "intended_not_on_air", "on_air_not_intended"];

/** `StatedFirmwareFindingGrade` */
export const STATED_FIRMWARE_FINDING_GRADE: readonly components["schemas"]["StatedFirmwareFindingGrade"][] = ["record_correction", "pin"];

/** `StatedFirmwareFindingSource` */
export const STATED_FIRMWARE_FINDING_SOURCE: readonly components["schemas"]["StatedFirmwareFindingSource"][] = ["carried", "generated"];

/** `StockAddRequest.source` */
export const STOCK_ADD_REQUEST_SOURCE: readonly NonNullable<components["schemas"]["StockAddRequest"]["source"]>[] = ["file", "order", "scan"];

/** `StockDeviceSource` */
export const STOCK_DEVICE_SOURCE: readonly components["schemas"]["StockDeviceSource"][] = ["file", "order", "scan"];

/** `StockImportRequest.source` */
export const STOCK_IMPORT_REQUEST_SOURCE: readonly NonNullable<components["schemas"]["StockImportRequest"]["source"]>[] = ["file", "order"];

/** `StockImportRowVerdict` */
export const STOCK_IMPORT_ROW_VERDICT: readonly components["schemas"]["StockImportRowVerdict"][] = ["added", "error"];

/** `SwitchCliSettingAppliedAction` */
export const SWITCH_CLI_SETTING_APPLIED_ACTION: readonly components["schemas"]["SwitchCliSettingAppliedAction"][] = ["set", "unset"];

/** `SwitchCliSettingAppliedDurability` */
export const SWITCH_CLI_SETTING_APPLIED_DURABILITY: readonly components["schemas"]["SwitchCliSettingAppliedDurability"][] = ["persisted", "running_config_only"];

/** `SwitchCliSettingAppliedReadBack` */
export const SWITCH_CLI_SETTING_APPLIED_READ_BACK: readonly components["schemas"]["SwitchCliSettingAppliedReadBack"][] = ["present", "absent", "unreadable"];

/** `SwitchCliSettingAppliedSetting` */
export const SWITCH_CLI_SETTING_APPLIED_SETTING: readonly components["schemas"]["SwitchCliSettingAppliedSetting"][] = ["snmp_community", "snmp_agent", "mrouter_port", "path_cost", "static_route", "syslog_facility", "dns_domain_lookup", "dns_domain_name"];

/** `SwitchCliSettingAppliedVerdict` */
export const SWITCH_CLI_SETTING_APPLIED_VERDICT: readonly components["schemas"]["SwitchCliSettingAppliedVerdict"][] = ["verified", "not_confirmed"];

/** `SwitchCliSettingApplyRequest.action` */
export const SWITCH_CLI_SETTING_APPLY_REQUEST_ACTION: readonly NonNullable<components["schemas"]["SwitchCliSettingApplyRequest"]["action"]>[] = ["set", "unset"];

/** `SwitchCliSettingApplyRequest.setting` */
export const SWITCH_CLI_SETTING_APPLY_REQUEST_SETTING: readonly NonNullable<components["schemas"]["SwitchCliSettingApplyRequest"]["setting"]>[] = ["snmp_community", "snmp_agent", "mrouter_port", "path_cost", "static_route", "syslog_facility", "dns_domain_lookup", "dns_domain_name"];

/** `SwitchCliSettingWithdrawalAction` */
export const SWITCH_CLI_SETTING_WITHDRAWAL_ACTION: readonly components["schemas"]["SwitchCliSettingWithdrawalAction"][] = ["unset"];

/** `SwitchCliSettingWithdrawalSetting` */
export const SWITCH_CLI_SETTING_WITHDRAWAL_SETTING: readonly components["schemas"]["SwitchCliSettingWithdrawalSetting"][] = ["dns_domain_lookup"];

/** `SwitchCliSettingsAdmissionAdmitted` */
export const SWITCH_CLI_SETTINGS_ADMISSION_ADMITTED: readonly components["schemas"]["SwitchCliSettingsAdmissionAdmitted"][] = ["snmp_community", "snmp_agent", "mrouter_port", "path_cost", "static_route", "syslog_facility", "dns_domain_lookup", "dns_domain_name"];

/** `SwitchFirstDocumentWithPortsLineField` */
export const SWITCH_FIRST_DOCUMENT_WITH_PORTS_LINE_FIELD: readonly components["schemas"]["SwitchFirstDocumentWithPortsLineField"][] = ["accepted", "accepted_disagreements", "accepted_port_reach", "accepted_removed_fates"];

/** `SwitchFirstDocumentWithPortsLineOrigin` */
export const SWITCH_FIRST_DOCUMENT_WITH_PORTS_LINE_ORIGIN: readonly components["schemas"]["SwitchFirstDocumentWithPortsLineOrigin"][] = ["read", "corpus", "port_plan"];

/** `SwitchHealthReadingSource` */
export const SWITCH_HEALTH_READING_SOURCE: readonly components["schemas"]["SwitchHealthReadingSource"][] = ["console"];

/** `SwitchImportDisposition` */
export const SWITCH_IMPORT_DISPOSITION: readonly components["schemas"]["SwitchImportDisposition"][] = ["modelled", "carried", "refused"];

/** `SwitchNameServersIntentState` */
export const SWITCH_NAME_SERVERS_INTENT_STATE: readonly components["schemas"]["SwitchNameServersIntentState"][] = ["keep", "stated", "removed"];

/** `SwitchPortField` */
export const SWITCH_PORT_FIELD: readonly components["schemas"]["SwitchPortField"][] = ["enabled", "description", "untagged_vlan", "tagged_vlans", "poe.enabled", "poe.priority", "poe.power_limit_mw", "voice.mode", "voice.priority", "voice.detect_voice", "edge_port"];

/** `SwitchPortMode` */
export const SWITCH_PORT_MODE: readonly components["schemas"]["SwitchPortMode"][] = ["access", "trunk"];

/** `SwitchPortPlanAdministrativePassword` */
export const SWITCH_PORT_PLAN_ADMINISTRATIVE_PASSWORD: readonly components["schemas"]["SwitchPortPlanAdministrativePassword"][] = ["set", "replaced", "unchanged"];

/** `SwitchPortPoEReadingAdmin` */
export const SWITCH_PORT_PO_E_READING_ADMIN: readonly components["schemas"]["SwitchPortPoEReadingAdmin"][] = ["enabled", "disabled"];

/** `SwitchPortPoEReadingOper` */
export const SWITCH_PORT_PO_E_READING_OPER: readonly components["schemas"]["SwitchPortPoEReadingOper"][] = ["on", "off"];

/** `SwitchPortStateLink` */
export const SWITCH_PORT_STATE_LINK: readonly components["schemas"]["SwitchPortStateLink"][] = ["up", "down"];

/** `SwitchPortStateSetKeyedBy` */
export const SWITCH_PORT_STATE_SET_KEYED_BY: readonly components["schemas"]["SwitchPortStateSetKeyedBy"][] = ["document", "report"];

/** `SwitchPortUnansweredField` */
export const SWITCH_PORT_UNANSWERED_FIELD: readonly components["schemas"]["SwitchPortUnansweredField"][] = ["link", "poe", "neighbour", "wan", "port"];

/** `SwitchPortUnansweredReason` */
export const SWITCH_PORT_UNANSWERED_REASON: readonly components["schemas"]["SwitchPortUnansweredReason"][] = ["offline", "no_report", "unreadable", "no_configuration", "silent", "vocabulary", "unreported", "disagreed", "unresolved", "aggregated"];

/** `SwitchPortsPoEReadingSource` */
export const SWITCH_PORTS_PO_E_READING_SOURCE: readonly components["schemas"]["SwitchPortsPoEReadingSource"][] = ["console"];

/** `SwitchReadState` */
export const SWITCH_READ_STATE: readonly components["schemas"]["SwitchReadState"][] = ["running", "done", "refused", "failed", "stopped", "interrupted"];

/** `SwitchReadStepState` */
export const SWITCH_READ_STEP_STATE: readonly components["schemas"]["SwitchReadStepState"][] = ["typing", "answered", "not_answered"];

/** `SwitchReleasedHeldAgainstSent` */
export const SWITCH_RELEASED_HELD_AGAINST_SENT: readonly components["schemas"]["SwitchReleasedHeldAgainstSent"][] = ["equal"];

/** `SwitchReleasedSource` */
export const SWITCH_RELEASED_SOURCE: readonly components["schemas"]["SwitchReleasedSource"][] = ["generated"];

/** `SwitchRemoteLogIntentState` */
export const SWITCH_REMOTE_LOG_INTENT_STATE: readonly components["schemas"]["SwitchRemoteLogIntentState"][] = ["keep", "stated", "removed"];

/** `SwitchRunningConfigurationHeld` */
export const SWITCH_RUNNING_CONFIGURATION_HELD: readonly components["schemas"]["SwitchRunningConfigurationHeld"][] = ["document", "stub", "none"];

/** `SwitchRunningConfigurationItemDisposition` */
export const SWITCH_RUNNING_CONFIGURATION_ITEM_DISPOSITION: readonly components["schemas"]["SwitchRunningConfigurationItemDisposition"][] = ["read", "supplied_from_corpus", "not_expressible", "refused"];

/** `SwitchRunningConfigurationItemFate` */
export const SWITCH_RUNNING_CONFIGURATION_ITEM_FATE: readonly components["schemas"]["SwitchRunningConfigurationItemFate"][] = ["unmeasured", "kept", "removed"];

/** `SwitchRunningConfigurationItemFirstDocumentEffect` */
export const SWITCH_RUNNING_CONFIGURATION_ITEM_FIRST_DOCUMENT_EFFECT: readonly components["schemas"]["SwitchRunningConfigurationItemFirstDocumentEffect"][] = ["stops", "asks", "none"];

/** `SwitchRunningConfigurationItemRefusedKind` */
export const SWITCH_RUNNING_CONFIGURATION_ITEM_REFUSED_KIND: readonly components["schemas"]["SwitchRunningConfigurationItemRefusedKind"][] = ["omitted_by_rule", "supplied_at_apply"];

/** `SwitchSessionHeldKind` */
export const SWITCH_SESSION_HELD_KIND: readonly components["schemas"]["SwitchSessionHeldKind"][] = ["read", "console", "poe_cycle"];

/** `SwitchSupplyHealthName` */
export const SWITCH_SUPPLY_HEALTH_NAME: readonly components["schemas"]["SwitchSupplyHealthName"][] = ["main", "redundant"];

/** `SwitchSupplyHealthStatus` */
export const SWITCH_SUPPLY_HEALTH_STATUS: readonly components["schemas"]["SwitchSupplyHealthStatus"][] = ["up", "down"];

/** `UnassignedDeviceOnlineState` */
export const UNASSIGNED_DEVICE_ONLINE_STATE: readonly components["schemas"]["UnassignedDeviceOnlineState"][] = ["online", "offline", "unknown"];

/** `UnassignedDeviceScriptRequest.read` */
export const UNASSIGNED_DEVICE_SCRIPT_REQUEST_READ: readonly NonNullable<components["schemas"]["UnassignedDeviceScriptRequest"]["read"]>[] = ["firmware", "board", "radios", "uptime", "gateway"];

/** `UnclaimedDeviceCategory` */
export const UNCLAIMED_DEVICE_CATEGORY: readonly components["schemas"]["UnclaimedDeviceCategory"][] = ["ap", "switch"];

/** `VenuePropagationOutcome` */
export const VENUE_PROPAGATION_OUTCOME: readonly components["schemas"]["VenuePropagationOutcome"][] = ["taken", "not_taken", "mixed", "incomplete"];

/** `VenuePropagationTurnAccessPointHeldAgainstSent` */
export const VENUE_PROPAGATION_TURN_ACCESS_POINT_HELD_AGAINST_SENT: readonly components["schemas"]["VenuePropagationTurnAccessPointHeldAgainstSent"][] = ["equal", "equal_except_named_empty_arrays", "differs", "not_compared"];

/** `VerticalKey` */
export const VERTICAL_KEY: readonly components["schemas"]["VerticalKey"][] = ["hospitality", "senior", "mdu", "corporate", "retail"];

/** `VlanMulticastVersion` */
export const VLAN_MULTICAST_VERSION: readonly components["schemas"]["VlanMulticastVersion"][] = [1, 2, 3];

/** `VlanNameProposalDisposition` */
export const VLAN_NAME_PROPOSAL_DISPOSITION: readonly components["schemas"]["VlanNameProposalDisposition"][] = ["proposed", "ambiguous", "named", "no_ssid"];

/** `WPA3Setting` */
export const WPA3_SETTING: readonly components["schemas"]["WPA3Setting"][] = ["off", "transition", "only"];

/** `WidgetType` */
export const WIDGET_TYPE: readonly components["schemas"]["WidgetType"][] = ["health", "attention", "sites", "firmware", "clients", "bands", "signal", "top_aps", "ssids", "organizations"];

/** `WidgetUnavailableReason` */
export const WIDGET_UNAVAILABLE_REASON: readonly components["schemas"]["WidgetUnavailableReason"][] = ["scope_wider_than_one_site"];

/** `WorkListCallMethod` */
export const WORK_LIST_CALL_METHOD: readonly components["schemas"]["WorkListCallMethod"][] = ["POST"];

/** `WorkListItemKind` */
export const WORK_LIST_ITEM_KIND: readonly components["schemas"]["WorkListItemKind"][] = ["switch", "venue", "reconciliation"];

/** `WorkListOutcomeOutcome` */
export const WORK_LIST_OUTCOME_OUTCOME: readonly components["schemas"]["WorkListOutcomeOutcome"][] = ["applied", "refused", "outcome_unknown"];
